module.exports = __webpack_public_path__ + "static/media/category9.7204a9b2.png";